/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Escalations } from './Escalations';
import {
    EscalationsFromJSON,
    EscalationsFromJSONTyped,
    EscalationsToJSON,
} from './Escalations';
import type { ListingId1 } from './ListingId1';
import {
    ListingId1FromJSON,
    ListingId1FromJSONTyped,
    ListingId1ToJSON,
} from './ListingId1';

/**
 * Response after successful form submission.
 * @export
 * @interface SubmitVisitFormResponse
 */
export interface SubmitVisitFormResponse {
    /**
     * Submission status: 'complete'
     * @type {string}
     * @memberof SubmitVisitFormResponse
     */
    status: string;
    /**
     * Submission timestamp
     * @type {Date}
     * @memberof SubmitVisitFormResponse
     */
    submittedAt: Date;
    /**
     * Completion timestamp
     * @type {Date}
     * @memberof SubmitVisitFormResponse
     */
    completedAt: Date;
    /**
     * 
     * @type {ListingId1}
     * @memberof SubmitVisitFormResponse
     */
    listingId?: ListingId1;
    /**
     * Success message
     * @type {string}
     * @memberof SubmitVisitFormResponse
     */
    message: string;
    /**
     * 
     * @type {Escalations}
     * @memberof SubmitVisitFormResponse
     */
    escalations?: Escalations;
}

/**
 * Check if a given object implements the SubmitVisitFormResponse interface.
 */
export function instanceOfSubmitVisitFormResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "submittedAt" in value;
    isInstance = isInstance && "completedAt" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function SubmitVisitFormResponseFromJSON(json: any): SubmitVisitFormResponse {
    return SubmitVisitFormResponseFromJSONTyped(json, false);
}

export function SubmitVisitFormResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitVisitFormResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'submittedAt': (new Date(json['submitted_at'])),
        'completedAt': (new Date(json['completed_at'])),
        'listingId': !exists(json, 'listing_id') ? undefined : ListingId1FromJSON(json['listing_id']),
        'message': json['message'],
        'escalations': !exists(json, 'escalations') ? undefined : EscalationsFromJSON(json['escalations']),
    };
}

export function SubmitVisitFormResponseToJSON(value?: SubmitVisitFormResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'submitted_at': (value.submittedAt.toISOString()),
        'completed_at': (value.completedAt.toISOString()),
        'listing_id': ListingId1ToJSON(value.listingId),
        'message': value.message,
        'escalations': EscalationsToJSON(value.escalations),
    };
}

